import { Keyboard } from '@capacitor/keyboard';
import { isNativePlatform } from './platformService.js';

export function listenForKeyboardChanges(onChange) {
  if (!isNativePlatform()) return () => {};

  const listenerHandles = [];
  let disposed = false;

  const show = (info) => onChange({ open: true, height: info.keyboardHeight ?? 0 });
  const hide = () => onChange({ open: false, height: 0 });

  Promise.all([
    Keyboard.addListener('keyboardWillShow', show),
    Keyboard.addListener('keyboardDidShow', show),
    Keyboard.addListener('keyboardWillHide', hide),
    Keyboard.addListener('keyboardDidHide', hide),
  ]).then((handles) => {
    if (disposed) {
      handles.forEach((handle) => void handle.remove());
      return;
    }
    listenerHandles.push(...handles);
  });

  return () => {
    disposed = true;
    listenerHandles.forEach((handle) => void handle.remove());
  };
}
